import { useEffect, useState } from "react";

/**
 * Returns a smaller PAGE_SIZE on mobile so long tables don't scroll the page —
 * users navigate more pages with the Pagination controls instead.
 * Mobile is anything under 768px.
 */
export function useResponsivePageSize(mobile = 10, desktop = 50) {
  const [size, setSize] = useState(() =>
    typeof window !== "undefined" && window.innerWidth < 768 ? mobile : desktop
  );
  useEffect(() => {
    const onResize = () => setSize(window.innerWidth < 768 ? mobile : desktop);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, [mobile, desktop]);
  return size;
}
